import * as moment from 'moment';
import { Organisme } from '../../intervenant/models/organisme.model';
import { Produit } from '../../habilitation/models/produit.model';
import { Operateur } from '../../intervenant/models/operateur.model';
import { Conditionnement } from '../../declaration/models/conditionnement.model';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { OperateurInformationsDomaine } from '../../intervenant/models/operateur-informations-domaine.model';
import { StatutEchantillon } from '../../declaration/models/statut-echantillon.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class Echantillon {
  static jsonMap = {
    id: { key: 'id' },
    codeProduit: { key: 'codeProduit' },
    idOperateur: { key: 'idOperateur' },
    idMouvement: { key: 'idMouvement', optional: true },
    conditionnement: { key: 'idConditionement', converter: new (DataIdConverterFactory.build(Conditionnement, 'conditionnements'))(), optional: true },
    millesime: { key: 'millesime', optional: true },
    organisme: { key: 'idOrganisme', converter: new (DataIdConverterFactory.build(Organisme, 'organismes'))(), optional: true },
    datePrelevement: { key: 'datePrelevement', converter: new DateTimeConverter() },
    degre: {key: 'degre', optional: true },
    volume: { key: 'volume', optional: true },
    numero: { key: 'numero', optional: true },
    ordre: { key: 'ordre', optional: true },
    codeStatut: { key: 'codeStatut', optional: true },
    logement: { key: 'logement', optional: true },
    expertise: { key: 'expertise', optional: true },
    passage: { key: 'passage', optional: true }
  };

  id: number;
  codeProduit: string;
  produit: Produit;
  idOperateur: number;
  infosOperateur: OperateurInformationsDomaine[] = [];
  operateur: Operateur;
  idMouvement: number;
  conditionnement: Conditionnement;
  millesime: number;
  organisme: Organisme;
  datePrelevement: moment.Moment;
  degre: string;
  volume: number;
  numero: string;
  ordre: number;
  codeStatut: string;
  cahier: string;
  couleur: string;
  logement: string;
  expertise: string;
  passage: string;

  statut: StatutEchantillon;
}
